/** The five tab-bar roots. Screens below them are "pushed" (back button, swipe back). */
export const TAB_ROOTS = ['/club', '/coaching', '/practice', '/progression', '/profile'] as const;

/** True only on a tab root itself (not on screens pushed from it). */
export function isTabRoot(pathname: string): boolean {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return (TAB_ROOTS as readonly string[]).includes(path);
}
